import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CadCategoriesApiResponse,
  CadWaterfallApiResponse,
  FETCH_CAD_CATEGORIES_TYPE,
  SUBMIT_CAD_WATERFALL_TYPE,
} from "../types";
import type { CadPercentByItemKey } from "../prepareWaterfallPayload";

export type SubmitCadWaterfallArg = {
  cadPercentByItemKey?: CadPercentByItemKey;
} | void;

export const fetchCadCategories = createAsyncThunk<
  CadCategoriesApiResponse,
  void,
  { rejectValue: string }
>(
  FETCH_CAD_CATEGORIES_TYPE,
  async (_, thunkAPI) => {
    try {
      const { default: DATAMART_API } = await import(
        "dot/Constants/services/datamart"
      );
      const response = await DATAMART_API.getCadCategories();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Failed to fetch CAD categories"
      );
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as {
        cadDiscounts?: {
          loading?: boolean;
          categories?: unknown[];
        };
      };
      if (state?.cadDiscounts?.loading) {
        return false;
      }
      return !(state?.cadDiscounts?.categories?.length);
    },
  }
);

export const submitCadWaterfall = createAsyncThunk<
  CadWaterfallApiResponse,
  SubmitCadWaterfallArg,
  { rejectValue: string }
>(
  SUBMIT_CAD_WATERFALL_TYPE,
  async (arg, thunkAPI) => {
    try {
      // Lazy import avoids thunk → systemLogics → mainStore → slice → thunk.
      const { buildSubmitWaterfallPayload } = await import(
        "../prepareWaterfallPayload"
      );
      const { default: DATAMART_API } = await import(
        "dot/Constants/services/datamart"
      );
      const cadPercentByItemKey =
        typeof arg === "object" && arg !== null
          ? arg.cadPercentByItemKey
          : undefined;
      const payload = buildSubmitWaterfallPayload(
        thunkAPI.getState(),
        cadPercentByItemKey
      );
      return await DATAMART_API.submitWaterfall(payload);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Failed to submit CAD waterfall"
      );
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as {
        cadDiscounts?: { waterfallLoading?: boolean };
      };
      return !state?.cadDiscounts?.waterfallLoading;
    },
  }
);
